import $ from 'jquery';
import BlockSort from './block-sort';
import PreviewUploadedImage from './file-upload';

export default class GiftCategoryVariant {
  constructor(sortableInit) {
    this.sortableInit = sortableInit;
    this.sortable = '';

    if ($(this.sortableInit).length) {
      this.init();
    }
  }

  initSort() {
    this.sortable = new BlockSort(this.sortableInit);
  }

  init() {
    this.initSort();

    $('body').on('click', '.js__variant-img-delete-btn', event => {
      event.preventDefault();
      $(event.currentTarget).closest('[data-form-collection="item"]').remove();
      $(document).trigger('collection-form-delete', [$(event.currentTarget)]);
      this.sortable.updateInputs(this.sortableInit);
    });

    new PreviewUploadedImage($('body'));
  }
}
